export default __webpack_public_path__ + "static/media/benefit_13.1fe4345a.png";